import path, { createRouteObject } from 'Router/path'
import component from 'Components/index'
import { RouteRecordRaw } from 'vue-router';

const router: RouteRecordRaw[] = [
    createRouteObject({
        path: path.bill,
        component: component.BillLandingPage
    }),
    createRouteObject({
        path: path.invoice,
        component: component.InvoiceLandingPage
    }),
    createRouteObject({
        path: path.invoiceDetail,
        component: component.InvoiceDetailPage
    }),
    createRouteObject({
        path: path.invoiceProduct,
        component: component.InvoiceProductLandingPage
    }),
    createRouteObject({
        path: path.invoiceAddProduct,
        component: component.InvoiceAddProductPage
    }),
    createRouteObject({
        path: path.invoicePackage,
        component: component.InvoicePackagePage
    }),
    createRouteObject({
        path: path.invoicePackagePayment,
        component: component.InvoicePackagePaymentPage
    }),
    createRouteObject({
        path: path.invoicePackageWallet,
        component: component.InvoicePackageWalletPage
    }),
    createRouteObject({
        path: path.InvoicePackageOrderCompleted,
        component: component.InvoicePackageOrderCompletedPage
    }),
    createRouteObject({
        path: path.InvoicePackagePaymentCompleted,
        component: component.InvoicePackagePaymentCompletedPage
    }),
    createRouteObject({
        path: path.createInvoice,
        component: component.InvoiceCreatePage
    }),
    createRouteObject({
        path: path.EditInvoice,
        component: component.InvoiceEditPage
    }),
    createRouteObject({
        path: path.invoiceChoosePaymentType,
        component: component.InvoiceChoosePaymentTypePage
    }),
    createRouteObject({
        path: path.invoiceChooseCurrency,
        component: component.InvoiceChooseCurrencyPage
    }),
    createRouteObject({
        path: path.editInvoiceInformation,
        component: component.InvoiceEditInformation
    }),
    createRouteObject({
        path: path.invoiceChooseShop,
        component: component.InvoiceChooseShopPage
    }),
    createRouteObject({
        path: path.invoiceFormShop,
        component: component.InvoiceFormShopPage
    }),
    createRouteObject({
        path: path.invoiceShopDetail,
        component: component.InvoiceShopDetailPage
    }),
    createRouteObject({
        path: path.invoiceChooseCustomer,
        component: component.InvoiceChooseCustomerPage
    }),
    createRouteObject({
        path: path.invoiceFormCustomer,
        component: component.InvoiceFormCustomerPage
    }),
    createRouteObject({
        path: path.invoiceCustomerDetail,
        component: component.InvoiceCustomerDetailPage
    }),
    createRouteObject({
        path: path.viewInvoice,
        component: component.ViewInvoicePage
    }),
]

export default router;